import { writable } from "svelte/store";
import type { Writable } from 'svelte/store';

export const loading: Writable<boolean> = writable(false);